import { Form } from "react-bootstrap"
import { Controller } from "react-hook-form"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
import FormLabel from "./FormLabel"

interface FormSelectProps {
  // defaultValue: any
  name: string
  title: string
  errors?: any
  control: any
  options: any[]
  isCreatable?: boolean
  isMulti?: boolean
  placeholder?: string
  className?: string
  disabled?: boolean
}

function FormSelect({
  // defaultValue,
  errors,
  title,
  name,
  control,
  options,
  isCreatable = false,
  isMulti,
  placeholder = "",
  className = "",
  disabled = false,
}: FormSelectProps) {
  return (
    <Form.Group className={className}>
      <FormLabel title={title} />
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, onBlur, value, name, ref } }) =>
          isCreatable ? (
            <CreatableSelect
              name={name}
              isMulti={isMulti}
              placeholder=""
              isDisabled={disabled}
              styles={{
                valueContainer: (provided, state) => ({
                  ...provided,
                  height: "42px",
                }),
              }}
              onBlur={onBlur} // notify when input is touched
              onChange={onChange} // send value to hook form
              value={value}
              ref={ref}
            />
          ) : (
            <Select
              // defaultValue={defaultValue}
              name={name}
              isMulti={isMulti}
              placeholder={placeholder}
              styles={{
                valueContainer: (provided, state) => ({
                  ...provided,
                  // height: "42px",
                }),
              }}
              isDisabled={disabled}
              onBlur={onBlur} // notify when input is touched
              onChange={onChange} // send value to hook form
              value={value}
              ref={ref}
              options={options}
            />
          )
        }
      />

      {errors && errors[name] ? (
        <div className="invalid-feedback d-block">
          {errors[name]["message"]}
        </div>
      ) : null}
    </Form.Group>
  )
}

export default FormSelect
